export const state = () => ({
  mayte: null,
  hearders: null,
})

export const mutations = {
  setMayte(state, value) {
    state.mayte = value
  },
  setHeaders(state, value) {
    state.hearders = value
  },
}
